import React from 'react';
import PropTypes from 'prop-types';
import { defineMessages } from 'react-intl';
import Message from 'components/Message';
import FeatureNotSupported from 'components/FeatureNotSupported';
import AutoSyncStatus from 'components/AutoSyncStatus';
import { Controls, Control, Title, Column, ColumnLayout } from 'features/App';
import AddInstructorButton from './AddInstructorButton';
import InstructorDetails from './InstructorDetails/InstructorDetailsContainer';
import InstructorsList from './InstructorsList/InstructorsList';

const messages = defineMessages({
  instructors: {
    id: 'instructors.title',
    defaultMessage: 'Instructors',
  },
});

const Instructors = ({
  instructors,
  activeVenueId,
  isLoading,
  selectedInstructorId,
  handleInstructorChange,
  shouldScrollToItem,
  featureIsSupported,
}) => (
  <ColumnLayout className="instructors" dataCypress="instructors">
    <Column className="column-layout__column--lg-1/3" name="list" type="flush">
      <Message message={messages.instructors} as={Title} />
      <Controls>
        <Control type="trough">
          <AutoSyncStatus />
        </Control>
        {featureIsSupported ? (
          <Control type="button">
            <AddInstructorButton activeVenueId={activeVenueId} />
          </Control>
        ) : (
          <Control type="trough">
            <FeatureNotSupported />
          </Control>
        )}
      </Controls>

      {featureIsSupported && (
        <InstructorsList
          instructors={instructors}
          isLoading={isLoading}
          handleInstructorChange={handleInstructorChange}
          selectedInstructorId={selectedInstructorId}
          instructorsTitleMessage={messages.instructors}
          shouldScrollToItem={shouldScrollToItem}
        />
      )}
    </Column>
    <Column className="column-layout__column--lg-2/3 lg-ml-l" name="details" type="flush">
      {featureIsSupported && <InstructorDetails activeVenueId={activeVenueId} instructorId={selectedInstructorId} />}
    </Column>
  </ColumnLayout>
);

Instructors.propTypes = {
  activeVenueId: PropTypes.number,
  featureIsSupported: PropTypes.bool,
  instructors: PropTypes.arrayOf(
    PropTypes.shape({
      id: PropTypes.number,
      firstName: PropTypes.string,
      lastName: PropTypes.string,
      pictureUrl: PropTypes.string,
    })
  ),
  isLoading: PropTypes.bool,
  selectedInstructorId: PropTypes.number,
  handleInstructorChange: PropTypes.func,
  shouldScrollToItem: PropTypes.bool,
};

export default Instructors;
